import { apBasePath } from "./_base";

export const apPathClaimAcctSent = apBasePath.appendPathSegment("/claim-acct-sent");